import styled from 'styled-components'

export const Wrapper = styled.div`
  svg {
    position: absolute;
    color: #d48806;
    font-size: 12px;
    margin-top: 4px;
    margin-left: 10px;
  }
`
